import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * SidebarContent - Main scrollable content area of sidebar
 */
export const SidebarContent = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex-1 overflow-auto py-4 overflow-x-hidden', className)}
    {...props}
  />
));
SidebarContent.displayName = 'SidebarContent';
